export const setPostageForm = () => {
    const postalSection = document.getElementById('postalSection')
    postalSection.classList.toggle("hide");
}


